import { Box, useTheme } from '@mui/material'
import { useContext, useState } from 'react'
import AddButton from 'components/add-button/add-button.component'
import {
  AddressContext,
  AddressProviderValue,
} from 'pages/address/address.provider'
import { useCarrierList } from 'pages/address/address.hooks'
import AddCarrierDialog from '../add-carrier-dialog/add-carrier-dialog.component'

const AddressCarrierAddButton = () => {
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const { setSelectedAssociationId } = useContext(
    AddressContext
  ) as AddressProviderValue
  const { refetch } = useCarrierList()

  const handleCreated = async (associationId: string) => {
    await refetch()
    setSelectedAssociationId(associationId)
  }

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: theme.palette.common.white,
          borderTop: `1px solid ${theme.palette.divider}`,
          mt: 'auto',
          flexShrink: 0,
          pt: 0.5,
          pb: 1,
          px: 0.5,
          minHeight: 60,
          overflow: 'hidden',
        }}
      >
        <AddButton label="Add Carrier" handleClick={() => setOpen(true)} />
      </Box>

      <AddCarrierDialog
        open={open}
        onClose={() => setOpen(false)}
        onCreated={handleCreated}
      />
    </>
  )
}

export default AddressCarrierAddButton
